var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M37 15.6h-7.6v-5c0-1.9 1.2-2.3 2.1-2.3h5.4V0h-7.4c-8.2 0-10.1 6.2-10.1 10.1v5.5h-4.8v8.5h4.8v24.1h10V24.1h6.8l.8-8.5z"}));
}

SocialFacebook.defaultProps = {"fill":"currentColor","viewBox":"0 0 51.6 48.3"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
